import NotificationAPI from './notification.api'

export default NotificationAPI
